<svg
  width="46"
  height="46"
  viewBox="0 0 46 46"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.0941 44.3143C34.8475 44.3143 44.3755 34.886 44.3755 23.2555C44.3755 11.6251 34.8475 2.19678 23.0941 2.19678C11.3407 2.19678 1.81274 11.6251 1.81274 23.2555C1.81274 34.886 11.3407 44.3143 23.0941 44.3143Z"
    fill="url(#paint0_linear_852_45133)"
  />
  <path
    d="M43.8755 23.2555C43.8755 34.6049 34.5763 43.8143 23.0941 43.8143C11.6119 43.8143 2.31274 34.6049 2.31274 23.2555C2.31274 11.9062 11.6119 2.69678 23.0941 2.69678C34.5763 2.69678 43.8755 11.9062 43.8755 23.2555Z"
    stroke="#774700"
    stroke-opacity="0.5"
  />
  <path
    d="M32.2258 33.0818H13.9636C12.1873 33.0818 12.1873 30.2739 13.9636 30.2739H32.2258C34.0021 30.2739 34.0021 33.0818 32.2258 33.0818Z"
    fill="#1A1626"
  />
  <path
    d="M15.9967 23.2554C17.5638 23.2554 18.8342 21.684 18.8342 19.7456C18.8342 17.8072 17.5638 16.2358 15.9967 16.2358C14.4296 16.2358 13.1592 17.8072 13.1592 19.7456C13.1592 21.684 14.4296 23.2554 15.9967 23.2554Z"
    fill="#1A1626"
  />
  <path
    d="M30.1886 23.2554C31.7557 23.2554 33.0261 21.684 33.0261 19.7456C33.0261 17.8072 31.7557 16.2358 30.1886 16.2358C28.6215 16.2358 27.3511 17.8072 27.3511 19.7456C27.3511 21.684 28.6215 23.2554 30.1886 23.2554Z"
    fill="#1A1626"
  />
  <defs>
    <linearGradient
      id="paint0_linear_852_45133"
      x1="23.0941"
      y1="44.3143"
      x2="23.0941"
      y2="2.19678"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FF7B00" />
      <stop offset="0.3236" stop-color="#FFAE00" />
      <stop offset="0.6205" stop-color="#FFD600" />
      <stop offset="0.8558" stop-color="#FFEE00" />
      <stop offset="1" stop-color="#FFF700" />
    </linearGradient>
  </defs>
</svg>
